import { render } from "./Register-consultant.vue?vue&type=template&id=ce036b18&scoped=true"
import script from "./Register-consultant.vue?vue&type=script&lang=js"
export * from "./Register-consultant.vue?vue&type=script&lang=js"

import "./Register-consultant.vue?vue&type=style&index=0&id=ce036b18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce036b18"]])

export default __exports__